import { useInsertAccountOneMutation, AccountFullFragment } from '@app/generated/graphql';
import DescriptionIcon from '@material-ui/icons/Description';
import { pageContent } from '@app/shared/hoc/page-content';
import React from 'react';
import PageTitle from '@app/shared/components/PageTitle';
import BackButton from '@app/shared/components/buttons/BackButton';
import { InfoCard } from '@mystiny/ui';
import { useResponseBar } from '@app/shared/hooks/useResponseBar';
import { FormProvider, useForm } from 'react-hook-form';
import Spacing from '@app/components/common/Spacing';
import { Typography } from '@material-ui/core';
import SaveButton from '@app/shared/components/buttons/SaveButton';
import Page from '@app/components/Page';
import { Form } from '@app/views/Account/components/Form';
import { useHistory } from 'react-router-dom';

const AccountCreate = () => {
  const form = useForm<AccountFullFragment>();
  const { enqueueSuccess, enqueueFailure } = useResponseBar();
  const history = useHistory();
  const [createFn] = useInsertAccountOneMutation({
    onCompleted: ({ insert_account_account_one }) => {
      history.push(`/bof/accounting/accounts/${insert_account_account_one?.id}`)
      enqueueSuccess('บันทึกข้อมูลสำเร็จ');
    },
    onError: (err: any) => {
      console.error(err);
      enqueueFailure('เกิดข้อผิดพลาด' + err);
    },
  });

  const handleSubmit = form.handleSubmit((formData: AccountFullFragment) => {
    createFn({
      variables: {
        object: {
          code: formData.code,
          name: formData.name,
          fiscal_year: formData.fiscal_year,
          note: formData.note,
          type_id: formData.type_id,
          category_id: formData.category_id,
          default_entry_type_id: formData.default_entry_type_id,
        },
      },
    });
  });

  return (
    <Page
      title={
        <PageTitle
          title={
            <React.Fragment>
              <Typography variant="h6" component="div">
                <DescriptionIcon color="primary" fontSize="small" /> สร้างผังบัญชี
              </Typography>
            </React.Fragment>
          }
          actions={
            <div>
              <BackButton to="/bof/accounting/accounts" />
            </div>
          }
        />
      }
    >
      <Spacing />
      <InfoCard title="ข้อมูลผังบัญชี" actionTopRight={<SaveButton onClick={handleSubmit} />}>
        <FormProvider {...form}>
          <Form mode="create" />
        </FormProvider>
      </InfoCard>
      <Spacing />
    </Page>
  );
};

export default pageContent(AccountCreate);
